import type { ApiDivision } from "@src/api/dictionaries/divisions";

/** Минимальные поля подразделения, достаточные для резолва default-кода. */
export type DivisionAssignment = Pick<ApiDivision, "Code" | "Type">;

/**
 * Возвращает default-код подразделения из ordered списка назначений пользователя. \
 * Правило: первое подразделение, подходящее под constraint по типам.
 *
 * @param divisions подразделения пользователя в порядке назначений
 * @param types допустимые коды типов; без списка / пустой — любое первое
 * @param allowedCodes допустимые коды после server-side проверки; без списка проверка не применяется
 * @returns код подразделения или `null`, если подходящего нет
 *
 * @example
 * ```ts
 * resolveDefaultDivisionCode(user.Divisions)
 * resolveDefaultDivisionCode(user.Divisions, [DivisionType.Склад])
 * resolveDefaultDivisionCode(user.Divisions, [DivisionType.Цех, DivisionType.Производство])
 * ```
 */
export function resolveDefaultDivisionCode(
    divisions: ReadonlyArray<DivisionAssignment>,
    types?: readonly number[],
    allowedCodes?: ReadonlySet<number>,
): number | null {
    const allowedTypes = types != null && types.length > 0 ? new Set(types) : null;

    for (const division of divisions) {
        const matchesType = allowedTypes == null || allowedTypes.has(division.Type);
        const isAllowed = allowedCodes == null || allowedCodes.has(division.Code);

        if (matchesType && isAllowed) {
            return division.Code;
        }
    }

    return null;
}
